import { render, staticRenderFns } from "./promo-row.vue?vue&type=template&id=8c3ef65a&"
import script from "./promo-row.vue?vue&type=script&lang=js&"
export * from "./promo-row.vue?vue&type=script&lang=js&"
import style0 from "./promo-row.vue?vue&type=style&index=0&id=8c3ef65a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports